<template>
  <v-container>
    <v-alert
      outlined
      type="info"
      color="green"
      border="left"
    >
      <div>
        ご要望があれば、以下のフォームに記載して送信いただければと思います。
      </div>
    </v-alert>
    <br>
    <div>
      <v-card>
        <v-container>
          <h2>要望</h2>
          投稿内容は管理人が確認します。<br>
          ※なお、奇怪なコメントはネタにさせていただきます。
          <v-form
            ref="form"
            v-model="valid"
            lazy-validation
          >
            <v-text-field
              v-model="inputComment"
              label="内容"
              required
            />
            <v-btn
              :disabled="!valid"
              @click="toukou"
            >
              投稿する
            </v-btn>
          </v-form>
          <v-dialog
            v-model="displayForm"
            max-width="500px"
          >
            <v-card>
              <v-container>
                <h2>以下の内容で投稿されますか？</h2>
                {{ inputComment }}
                <br>
                <v-btn
                  class="ma-2 pa-1"
                  @click="addComment"
                >
                  はい
                </v-btn>
                <v-btn
                  class="ma-2 pa-1"
                  @click="modalClose"
                >
                  いいえ
                </v-btn>
              </v-container>
            </v-card>
          </v-dialog>
        </v-container>
      </v-card>
    </div>
    <br>
    <!-- <v-alert
      type="success"
    >
      要望一覧
    </v-alert> -->
    <!-- <v-list three-line>
      <template v-for="(comment, index) in comments">
        <v-list-item
          :key="index"
          avatar
        >
          <v-list-item-avatar>
            <img :src="comment.avatar">
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-subtitle class="text--primary subheading">
              {{ comment.content }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              {{ comment.createdAt.toDate().toLocaleString() }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-action />
          <v-btn
            class="btn btn-primary"
            @click.once="agreeCount(comment.id)"
          >
            賛同数（クリック）
            {{ comment.agree }}
          </v-btn>
        </v-list-item>
        <v-divider :key="comment.id" />
      </template>
    </v-list> -->
  </v-container>
</template>

<script>
  import { db } from '../../../main'

  export default {
    data: () => ({
      comments: [],
      outputAll: [],
      inputComment: '',
      displayForm: false,
      message: '',
    }),
    firestore () {
      return {
        comments: db.collection('comments'),
      }
    },
    methods: {
      toukou () {
        this.displayForm = true
      },
      // コメント追加
      addComment () {
        const now = new Date()
        // コメントをFirestoreへ登録
        db.collection('request').add({
          content: this.inputComment,
          avatar: 'https://picsum.photos/50?image=' + (Math.floor(Math.random() * 300) + 1),
          createdAt: now,
          agree: 0,
        })
        this.displayForm = false
        this.inputComment = ''
      },
      modalClose () {
        this.displayForm = false
      },
      // Formの初期化
      clear () {
        this.$refs.form.reset()
      },
      agreeCount (argDoc) {
        const revise = db.collection('comments').doc(argDoc)
        revise.get().then((doc) => {
          if (doc.exists) {
            revise.update({
              agree: doc.data().agree + 1,
            })
          }
        })
      },
    },
    head: {
      meta: [
        { name: 'description', content: 'Document Checkerへの要望をお願いします。' },
        { property: 'og:title', content: 'Document Checkerへの要望' },
        { property: 'og:description', content: 'Document Checkerへの要望をお願いします。' },
        { property: 'og:type', content: 'website' },
        { property: 'og:url', content: 'https://document-checker-project.web.app/#/Request' },
        { property: 'og:image', content: 'https://document-checker-project.web.app/favicon.ico' },
        { name: 'twitter:card', content: 'summary' },
      ],
    },
  }
</script>
